// extracted by mini-css-extract-plugin
export var button = "PageArticleCategory-module--button--k3GGB";
export var filtersDesktop = "PageArticleCategory-module--filtersDesktop--BVJxa";
export var filtersMobile = "PageArticleCategory-module--filtersMobile--iuTW7";
export var products = "PageArticleCategory-module--products--F29Si";